module.exports = __webpack_public_path__ + "static/media/TA274_0.459dbfcd.png";